import * as React from "react";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import SharedEntitiesOverview from "components/permissions/SharedEntitiesOverview";
import SectionComponent from "components/common/Section/SectionComponent";
import TeamsDomain from "../../domainActions/TeamsDomain";
const SharedEntitiesSection = ({ teamId }) => {
  const { t } = useTranslation("enterprise_security");
  const [loading, setLoading] = useState(false);
  const _searchPaginated = useCallback(
    (pagination) => TeamsDomain.loadTeamSharesPaginated(teamId, pagination),
    [teamId]
  );
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: t("team_details_shared_entities.title"), showLoading: loading }, /* @__PURE__ */ React.createElement(SharedEntitiesOverview, { setLoading, entityType: "team", searchPaginated: _searchPaginated }));
};
export default SharedEntitiesSection;
